/* Scroll animations powered by AOS */
    function applyScrollAnimation(selector, animation, options = {}) {
      const {
        delay = 0,
        duration,
        stagger = 0,
        resetEvery = 4,
        offset
      } = options;

      document.querySelectorAll(selector).forEach((element, index) => {
        element.dataset.aos = animation;

        const staggerIndex = resetEvery > 0 ? index % resetEvery : index;
        const elementDelay = delay + (stagger * staggerIndex);

        if (elementDelay) {
          element.dataset.aosDelay = String(elementDelay);
        }

        if (duration) {
          element.dataset.aosDuration = String(duration);
        }

        if (offset !== undefined) {
          element.dataset.aosOffset = String(offset);
        }
      });
    }

    /* Above-the-fold content (homepage hero text/CTAs, product gallery + buy box, kit gallery + purchase panel,
       collection hero) is intentionally NOT animated: hiding it until AOS runs delayed LCP and caused a flash.
       Animations are kept for the sections below the fold. */

    applyScrollAnimation(".section-head > div", "fade-right", { duration: 700 });
    applyScrollAnimation(".section-head > .section-copy", "fade-left", { delay: 100, duration: 700 });
    applyScrollAnimation(".tabs", "fade-up", { delay: 120, duration: 750 });

    applyScrollAnimation(".video-tile", "fade-right", { duration: 750 });
    applyScrollAnimation(".why-grid > div:last-child", "fade-left", { delay: 120, duration: 750 });
    applyScrollAnimation(".why-item", "fade-up", { delay: 100, stagger: 90, resetEvery: 4, duration: 650 });

    applyScrollAnimation(".industry-card", "fade-up", { stagger: 110, resetEvery: 3, duration: 700 });
    applyScrollAnimation(".package-card", "fade-up", { stagger: 120, resetEvery: 3, duration: 700 });

    applyScrollAnimation(".spray-content", "fade-right", { duration: 750 });
    applyScrollAnimation(".spray-product", "zoom-in-left", { delay: 140, duration: 850 });

    applyScrollAnimation(".compare-list:first-child", "fade-right", { duration: 700 });
    applyScrollAnimation(".comparison .slider", "zoom-in", { delay: 100, duration: 750 });
    applyScrollAnimation(".compare-list:last-child", "fade-left", { delay: 180, duration: 700 });

    applyScrollAnimation(".audiences-title", "fade-up", { duration: 700 });
    applyScrollAnimation(".audience-card", "fade-up", { stagger: 90, resetEvery: 4, duration: 700 });

    applyScrollAnimation(".partner-section-head", "fade-up", { duration: 700 });
    applyScrollAnimation(".partner-visual", "fade-right", { duration: 750 });
    applyScrollAnimation(".partner-copy", "fade-left", { delay: 120, duration: 750 });
    applyScrollAnimation(".partner-points li", "fade-up", { delay: 100, stagger: 80, resetEvery: 4, duration: 600 });

    applyScrollAnimation(".product-tile", "fade-up", { stagger: 90, resetEvery: 4, duration: 700 });
    applyScrollAnimation(".nghs-product-copy-panel", "fade-right", { duration: 750, offset: 40 });
    applyScrollAnimation(".nghs-featured-product__content", "fade-left", { delay: 180, duration: 750, offset: 40 });
    applyScrollAnimation(".nghs-product-proof-strip > div", "fade-up", { stagger: 90, resetEvery: 3, duration: 650 });
    applyScrollAnimation(".nghs-product-description-card", "fade-right", { duration: 700 });
    applyScrollAnimation(".nghs-product-side-stack > div", "fade-left", { stagger: 90, resetEvery: 2, duration: 700 });
    applyScrollAnimation(".nghs-product-accordion-grid > details", "fade-up", { stagger: 80, resetEvery: 2, duration: 650 });
    applyScrollAnimation(".nghs-kit-information-grid > article", "fade-up", { stagger: 90, resetEvery: 3, duration: 700, offset: 45 });
    applyScrollAnimation(".nghs-kit-faq-wrap > *", "fade-up", { stagger: 100, resetEvery: 2, duration: 700, offset: 45 });
    applyScrollAnimation(".nghs-kit-process-heading", "fade-up", { duration: 700, offset: 45 });
    applyScrollAnimation(".nghs-kit-process-card", "fade-up", { stagger: 100, resetEvery: 3, duration: 720, offset: 45 });
    applyScrollAnimation(".nghs-kit-reviews-heading > *", "fade-up", { stagger: 90, resetEvery: 2, duration: 700, offset: 45 });
    applyScrollAnimation(".nghs-kit-judge-panel", "fade-up", { delay: 110, duration: 760, offset: 45 });
    applyScrollAnimation(".nghs-kit-specs-copy", "fade-right", { duration: 720, offset: 45 });
    applyScrollAnimation(".nghs-kit-specs-media", "zoom-in", { delay: 110, duration: 800, offset: 45 });
    applyScrollAnimation(".nghs-kit-spec-grid > article", "fade-up", { stagger: 80, resetEvery: 3, duration: 680, offset: 45 });
    applyScrollAnimation(".nghs-kit-final-cta", "fade-up", { duration: 760, offset: 45 });
    applyScrollAnimation(".nghs-collection-feature-card, .nghs-featured-collection-card, .nghs-featured-collection .nghs-related-card", "fade-left", { delay: 160, duration: 750, offset: 40 });
    applyScrollAnimation(".nghs-collection-command-bar, .nghs-collection-list-head", "fade-up", { duration: 700, offset: 50 });
    applyScrollAnimation(".nghs-collection-facets", "fade-right", { duration: 700, offset: 50 });
    applyScrollAnimation(".nghs-collection-product-card, .nghs-collection-card", "fade-up", { stagger: 90, resetEvery: 3, duration: 700, offset: 50 });
    applyScrollAnimation(".nghs-page-hero-copy, .nghs-blog-hero-copy", "fade-right", { duration: 750, offset: 40 });
    applyScrollAnimation(".nghs-page-hero-panel, .nghs-featured-article-card", "fade-left", { delay: 140, duration: 780, offset: 40 });
    applyScrollAnimation(".nghs-content-metrics > div", "fade-up", { stagger: 90, resetEvery: 3, duration: 650, offset: 50 });
    applyScrollAnimation(".nghs-page-content-card", "fade-right", { duration: 700, offset: 50 });
    applyScrollAnimation(".nghs-page-sidebar > div", "fade-left", { stagger: 90, resetEvery: 3, duration: 700, offset: 50 });
    applyScrollAnimation(".nghs-collapsible__heading-wrap", "fade-right", { duration: 720, offset: 45 });
    applyScrollAnimation(".nghs-collapsible__media, .nghs-collapsible__signal", "zoom-in", { delay: 100, duration: 780, offset: 45 });
    applyScrollAnimation(".nghs-collapsible__content-head", "fade-down", { duration: 620, offset: 35 });
    applyScrollAnimation(".nghs-collapsible__item", "fade-up", { stagger: 75, resetEvery: 5, duration: 650, offset: 35 });
    applyScrollAnimation(".nghs-blog-tags", "fade-up", { duration: 650, offset: 40 });
    applyScrollAnimation(".nghs-blog-card", "fade-up", { stagger: 90, resetEvery: 3, duration: 700, offset: 50 });
    applyScrollAnimation(".nghs-article-hero-copy", "fade-up", { duration: 720, offset: 30 });
    applyScrollAnimation(".nghs-article-hero-media", "zoom-in", { delay: 100, duration: 800, offset: 35 });
    applyScrollAnimation(".nghs-article-content-card, .nghs-article-author-card", "fade-up", { stagger: 90, resetEvery: 2, duration: 700, offset: 45 });
    applyScrollAnimation(".nghs-article-sidebar > *", "fade-left", { stagger: 90, resetEvery: 3, duration: 700, offset: 45 });
    applyScrollAnimation(".nghs-related-articles-head", "fade-up", { duration: 680, offset: 45 });
    applyScrollAnimation(".nghs-article-comments", "fade-up", { duration: 700, offset: 45 });
    applyScrollAnimation(".footer-grid > div", "fade-up", { stagger: 70, resetEvery: 5, duration: 650, offset: 40 });
    applyScrollAnimation(".footer-bottom", "fade-up", { delay: 120, duration: 600, offset: 20 });

    if (window.AOS) {
      AOS.init({
        once: true,
        mirror: false,
        offset: 90,
        duration: 700,
        easing: "ease-out-cubic",
        anchorPlacement: "top-bottom",
        disable: () => window.matchMedia("(prefers-reduced-motion: reduce)").matches
      });

      window.addEventListener("load", () => AOS.refresh());
    }

    function initializeSiteHeaders(scope = document) {
      scope.querySelectorAll("[data-nghs-header]").forEach((header) => {
        if (header.dataset.headerInitialized === "true") {
          return;
        }

        header.dataset.headerInitialized = "true";
        const controller = new AbortController();
        const { signal } = controller;
        const menuToggle = header.querySelector("[data-nghs-header-toggle]");
        const drawer = header.querySelector("[data-nghs-header-drawer]");
        const drawerPanel = drawer ? drawer.querySelector(".nghs-header__drawer-panel") : null;
        const closeButtons = drawer ? drawer.querySelectorAll("[data-nghs-header-close]") : [];
        const submenuButtons = Array.from(header.querySelectorAll("[data-nghs-submenu-toggle]"));
        const mobileShopBar = header.querySelector("[data-nghs-mobile-shop-bar]");
        let lastFocusedElement = null;

        if (mobileShopBar) {
          document.body.classList.add("nghs-has-mobile-shop-bar");
        }

        function closeDesktopSubmenus(exceptItem = null) {
          submenuButtons.forEach((button) => {
            const menuItem = button.closest(".nghs-header__menu-item");

            if (!menuItem || menuItem === exceptItem) {
              return;
            }

            menuItem.classList.remove("is-open");
            button.setAttribute("aria-expanded", "false");
          });
        }

        function setDrawerOpen(isOpen, restoreFocus = true) {
          if (!drawer || !menuToggle) {
            return;
          }

          drawer.classList.toggle("is-open", isOpen);
          drawer.setAttribute("aria-hidden", String(!isOpen));
          menuToggle.setAttribute("aria-expanded", String(isOpen));

          if (isOpen) {
            lastFocusedElement = document.activeElement;
            document.body.classList.add("nghs-header-drawer-open");
            window.requestAnimationFrame(() => {
              const closeButton = drawer.querySelector(".nghs-header__drawer-close");
              (closeButton || drawerPanel).focus();
            });
          } else {
            const hasOpenDrawer = Boolean(document.querySelector("[data-nghs-header-drawer].is-open"));
            document.body.classList.toggle("nghs-header-drawer-open", hasOpenDrawer);

            drawer.querySelectorAll("details[open]").forEach((details) => {
              details.open = false;
            });

            if (restoreFocus && lastFocusedElement && document.contains(lastFocusedElement)) {
              lastFocusedElement.focus();
            }
          }
        }

        if (menuToggle && drawer) {
          menuToggle.addEventListener("click", () => {
            setDrawerOpen(!drawer.classList.contains("is-open"));
          }, { signal });

          closeButtons.forEach((button) => {
            button.addEventListener("click", () => setDrawerOpen(false), { signal });
          });
        }

        submenuButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const menuItem = button.closest(".nghs-header__menu-item");

            if (!menuItem) {
              return;
            }

            const willOpen = !menuItem.classList.contains("is-open");
            closeDesktopSubmenus(menuItem);
            menuItem.classList.toggle("is-open", willOpen);
            button.setAttribute("aria-expanded", String(willOpen));
          }, { signal });
        });

        document.addEventListener("click", (event) => {
          if (!event.target.closest(".nghs-header__menu-item.has-dropdown")) {
            closeDesktopSubmenus();
          }
        }, { signal });

        document.addEventListener("keydown", (event) => {
          const drawerIsOpen = Boolean(drawer && drawer.classList.contains("is-open"));

          if (event.key === "Escape") {
            if (drawerIsOpen) {
              setDrawerOpen(false);
            } else {
              closeDesktopSubmenus();
            }
            return;
          }

          if (event.key !== "Tab" || !drawerIsOpen || !drawerPanel) {
            return;
          }

          const focusableElements = Array.from(drawerPanel.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
          )).filter((element) => element.offsetParent !== null);

          if (!focusableElements.length) {
            event.preventDefault();
            drawerPanel.focus();
            return;
          }

          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }, { signal });

        window.addEventListener("resize", () => {
          if (window.innerWidth > 1500 && drawer && drawer.classList.contains("is-open")) {
            setDrawerOpen(false, false);
          }
        }, { passive: true, signal });

        document.addEventListener("shopify:section:unload", (event) => {
          if (event.target.contains(header)) {
            setDrawerOpen(false, false);
            controller.abort();
            window.requestAnimationFrame(() => {
              document.body.classList.toggle(
                "nghs-has-mobile-shop-bar",
                Boolean(document.querySelector("[data-nghs-mobile-shop-bar]"))
              );
            });
          }
        }, { signal });
      });
    }

    initializeSiteHeaders();

    document.addEventListener("shopify:section:load", (event) => {
      initializeSiteHeaders(event.target);
    });

    const tabButtons = document.querySelectorAll(".tab-button");
    const tabPanels = document.querySelectorAll(".tab-panel");

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        tabButtons.forEach((item) => item.setAttribute("aria-selected", "false"));
        tabPanels.forEach((panel) => panel.classList.remove("active"));

        button.setAttribute("aria-selected", "true");
        const activePanel = document.querySelector(`#${button.getAttribute("aria-controls")}`);

        if (activePanel) {
          activePanel.classList.add("active");
        }

        if (window.AOS) {
          window.setTimeout(() => AOS.refresh(), 50);
        }
      });
    });

    const heroProductImage = document.querySelector("#hero-product-image");
    const heroProductDots = document.querySelector("#hero-product-dots");
    const heroProductPrev = document.querySelector("[data-hero-product-prev]");
    const heroProductNext = document.querySelector("[data-hero-product-next]");

    if (heroProductImage && heroProductDots && heroProductPrev && heroProductNext) {
      const heroProductRoot = heroProductImage.closest(".hero-product");
      const heroProducts = Array.from(heroProductRoot ? heroProductRoot.querySelectorAll("[data-hero-product-sources] [data-src]") : [])
        .map((source) => ({
          src: source.dataset.src,
          alt: source.dataset.alt || "NextGen featured product"
        }))
        .filter((product) => product.src);

      if (heroProducts.length) {
        let heroProductIndex = 0;

        heroProducts.forEach((product, index) => {
          const dot = document.createElement("button");
          dot.className = "hero-product-dot";
          dot.type = "button";
          dot.setAttribute("aria-label", `Show ${product.alt}`);
          dot.addEventListener("click", () => setHeroProduct(index));
          heroProductDots.appendChild(dot);
        });

        const heroProductDotButtons = heroProductDots.querySelectorAll(".hero-product-dot");

        function setHeroProduct(nextIndex) {
          heroProductIndex = (nextIndex + heroProducts.length) % heroProducts.length;
          const product = heroProducts[heroProductIndex];

          heroProductImage.style.opacity = "0";

          window.setTimeout(() => {
            heroProductImage.src = product.src;
            heroProductImage.alt = product.alt;
            heroProductImage.style.opacity = "1";
          }, 120);

          heroProductDotButtons.forEach((dot, index) => {
            dot.classList.toggle("active", index === heroProductIndex);
            dot.setAttribute("aria-current", index === heroProductIndex ? "true" : "false");
          });
        }

        heroProductPrev.addEventListener("click", () => setHeroProduct(heroProductIndex - 1));
        heroProductNext.addEventListener("click", () => setHeroProduct(heroProductIndex + 1));
        setHeroProduct(0);
      }
    }

    document.querySelectorAll(".nghs-product-gallery-shell").forEach((gallery) => {
      const featuredImage = gallery.querySelector(".nghs-product-featured-image");
      const thumbnails = gallery.querySelectorAll("[data-product-thumb]");

      if (!featuredImage || !thumbnails.length) {
        return;
      }

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener("click", () => {
          const nextSrc = thumbnail.dataset.fullSrc;
          const nextAlt = thumbnail.dataset.fullAlt || featuredImage.alt;

          if (!nextSrc) {
            return;
          }

          featuredImage.style.opacity = "0";
          featuredImage.style.transform = "scale(.985)";

          window.setTimeout(() => {
            featuredImage.removeAttribute("srcset");
            featuredImage.removeAttribute("sizes");
            featuredImage.src = nextSrc;
            featuredImage.alt = nextAlt;
            featuredImage.style.opacity = "1";
            featuredImage.style.transform = "scale(1)";
          }, 120);

          thumbnails.forEach((item) => {
            item.classList.toggle("active", item === thumbnail);
            item.setAttribute("aria-current", item === thumbnail ? "true" : "false");
          });
        });
      });
    });

    document.querySelectorAll("[data-kit-gallery]").forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll("[data-kit-media]"));
      const thumbnails = Array.from(gallery.querySelectorAll("[data-kit-thumb]"));
      const previousButton = gallery.querySelector("[data-kit-media-prev]");
      const nextButton = gallery.querySelector("[data-kit-media-next]");
      const count = gallery.querySelector("[data-kit-media-count]");

      if (!slides.length) {
        return;
      }

      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("active")));

      gallery.querySelectorAll("[data-kit-video-facade]").forEach((facade) => {
        const playButton = facade.querySelector("[data-kit-video-play]");
        const template = facade.querySelector("template[data-kit-video-template]");

        if (!playButton || !template) {
          return;
        }

        playButton.addEventListener("click", () => {
          const fragment = template.content.cloneNode(true);
          const video = fragment.querySelector("video");

          facade.replaceChildren(fragment);

          if (video) {
            video.preload = "auto";
            const playPromise = video.play();

            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(() => {});
            }

            video.focus({ preventScroll: true });
          }
        }, { once: true });
      });

      function showKitMedia(nextIndex) {
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle("active", isActive);
          slide.hidden = !isActive;

          if (!isActive) {
            slide.querySelectorAll("video").forEach((video) => video.pause());
          }
        });

        thumbnails.forEach((thumbnail, index) => {
          const isActive = index === activeIndex;
          thumbnail.classList.toggle("active", isActive);
          thumbnail.setAttribute("aria-current", isActive ? "true" : "false");
        });

        if (count) {
          count.textContent = `${activeIndex + 1} / ${slides.length}`;
        }
      }

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener("click", () => {
          showKitMedia(Number(thumbnail.dataset.mediaIndex || 0));
        });
      });

      if (previousButton) {
        previousButton.addEventListener("click", () => showKitMedia(activeIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener("click", () => showKitMedia(activeIndex + 1));
      }

      showKitMedia(activeIndex);
    });

    const productPaymentTermsMetadata = new WeakMap();
    const initializedKitQuantityForms = new WeakSet();
    const productPurchaseForms = ".nghs-product-form, .nghs-kit-product-form, .nghs-featured-product__form";

    function updateProductPaymentTerms(form) {
      const paymentTerms = form.querySelector("shopify-payment-terms");
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? Number(quantityInput.value) : 1;

      if (!paymentTerms || !Number.isSafeInteger(quantity) || quantity < 1 ||
          (quantityInput && !quantityInput.validity.valid)) {
        return;
      }

      if (!productPaymentTermsMetadata.has(paymentTerms)) {
        try {
          const original = paymentTerms.getAttribute("shopify-meta");
          const metadata = JSON.parse(original);

          if (metadata?.type !== "product" || !Array.isArray(metadata.variants) ||
              !Array.isArray(metadata.financing_plans) ||
              !Number.isFinite(metadata.min_price_amount) || !Number.isFinite(metadata.max_price_amount) ||
              !metadata.variants.every((variant) => Number.isFinite(variant.full_price_amount))) {
            return;
          }

          const formatter = new Intl.NumberFormat(document.documentElement.lang || "en", {
            style: "currency",
            currency: metadata.currency_code,
            currencyDisplay: "narrowSymbol"
          });

          // Keep unit prices intact so repeated quantity changes never compound totals.
          productPaymentTermsMetadata.set(paymentTerms, { original, metadata, formatter });
        } catch (error) {
          // Leave Shopify's original banner intact if its metadata format changes.
          return;
        }
      }

      const { original, metadata, formatter } = productPaymentTermsMetadata.get(paymentTerms);
      const minorUnits = 10 ** formatter.resolvedOptions().maximumFractionDigits;
      const minPrice = Math.round(metadata.min_price_amount * minorUnits);
      const maxPrice = Math.round(metadata.max_price_amount * minorUnits);
      const variants = metadata.variants.map((variant) => {
        const unitPrice = Math.round(variant.full_price_amount * minorUnits);
        const totalPrice = unitPrice * quantity;
        const plan = metadata.financing_plans.find((candidate) =>
          totalPrice >= Math.round(candidate.min_price_amount * minorUnits) &&
          totalPrice <= Math.round(candidate.max_price_amount * minorUnits)
        );
        const splitPayTerms = (plan?.terms || []).filter((term) =>
          term.loan_type === "split_pay" && term.apr === 0
        );
        // Allow a quantity increase to meet the minimum, but preserve other exclusions.
        const eligibleProduct = variant.eligible || unitPrice < minPrice || unitPrice > maxPrice;

        return {
          ...variant,
          full_price: formatter.format(totalPrice / minorUnits),
          full_price_amount: totalPrice / minorUnits,
          eligible: Boolean(eligibleProduct && plan && totalPrice >= minPrice && totalPrice <= maxPrice),
          number_of_payment_terms: splitPayTerms.length
            ? Math.max(...splitPayTerms.map((term) => term.installments_count))
            : variant.number_of_payment_terms
        };
      });

      // Shopify derives the repayment amounts and modal from the total and its own plans.
      const nextMetadata = quantity === 1 ? original : JSON.stringify({ ...metadata, variants });
      if (paymentTerms.getAttribute("shopify-meta") !== nextMetadata) {
        paymentTerms.setAttribute("shopify-meta", nextMetadata);
      }

      const variantInput = form.querySelector('[name="id"]');
      if (variantInput && paymentTerms.getAttribute("variant-id") !== variantInput.value) {
        paymentTerms.setAttribute("variant-id", variantInput.value);
      }
    }

    function initializeProductPurchaseForms(scope = document) {
      scope.querySelectorAll(productPurchaseForms).forEach((form) => {
        updateProductPaymentTerms(form);

        const quantity = form.querySelector('input[name="quantity"]');
        const minusButton = form.querySelector("[data-kit-qty-minus]");
        const plusButton = form.querySelector("[data-kit-qty-plus]");

        if (!quantity || !minusButton || !plusButton || initializedKitQuantityForms.has(form)) {
          return;
        }

        initializedKitQuantityForms.add(form);
        minusButton.addEventListener("click", () => {
          quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
          quantity.dispatchEvent(new Event("change", { bubbles: true }));
        });

        plusButton.addEventListener("click", () => {
          quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
          quantity.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    }

    function handleProductPaymentTermsChange(event) {
      const input = event.target;
      if (input.matches?.('[name="quantity"], [name="id"]') && input.form?.matches(productPurchaseForms)) {
        updateProductPaymentTerms(input.form);
      }
    }

    initializeProductPurchaseForms();
    document.addEventListener("input", handleProductPaymentTermsChange);
    document.addEventListener("change", handleProductPaymentTermsChange);
    window.addEventListener("pageshow", () => initializeProductPurchaseForms());
    document.addEventListener("shopify:section:load", (event) => {
      initializeProductPurchaseForms(event.target);
    });

    const slider = document.querySelector("#comparison-slider");
    const sliderInput = slider ? slider.querySelector("input") : null;

    if (slider && sliderInput) {
      function setComparisonSplit(value) {
        const boundedValue = Math.max(8, Math.min(92, value));

        slider.style.setProperty("--split", `${boundedValue}%`);
        sliderInput.value = String(Math.round(boundedValue));
      }

      function setComparisonSplitFromPointer(event) {
        const rect = slider.getBoundingClientRect();
        const value = ((event.clientX - rect.left) / rect.width) * 100;

        setComparisonSplit(value);
      }

      sliderInput.addEventListener("input", (event) => {
        setComparisonSplit(Number(event.target.value));
      });

      let isComparisonDragging = false;

      slider.addEventListener("pointerdown", (event) => {
        if (event.target === sliderInput || event.button !== 0) {
          return;
        }

        isComparisonDragging = true;
        slider.setPointerCapture(event.pointerId);
        setComparisonSplitFromPointer(event);
        event.preventDefault();
      });

      slider.addEventListener("pointermove", (event) => {
        if (!isComparisonDragging) {
          return;
        }

        setComparisonSplitFromPointer(event);
        event.preventDefault();
      });

      slider.addEventListener("pointerup", (event) => {
        isComparisonDragging = false;
        if (slider.hasPointerCapture(event.pointerId)) {
          slider.releasePointerCapture(event.pointerId);
        }
      });

      slider.addEventListener("pointercancel", (event) => {
        isComparisonDragging = false;
        if (slider.hasPointerCapture(event.pointerId)) {
          slider.releasePointerCapture(event.pointerId);
        }
      });
    }

    function initializeStickyAddToCart(scope = document) {
      scope.querySelectorAll("[data-nghs-sticky-atc]").forEach((stickyBar) => {
        if (stickyBar.dataset.stickyAtcInitialized === "true") {
          return;
        }

        stickyBar.dataset.stickyAtcInitialized = "true";

        const controller = new AbortController();
        const signal = controller.signal;
        const closeButton = stickyBar.querySelector("[data-sticky-atc-close]");
        const variantSelect = stickyBar.querySelector("[data-sticky-atc-variant]");
        const price = stickyBar.querySelector("[data-sticky-atc-price]");
        const comparePrice = stickyBar.querySelector("[data-sticky-atc-compare-price]");
        const image = stickyBar.querySelector("[data-sticky-atc-image]");
        const submitButton = stickyBar.querySelector("[data-sticky-atc-submit]");
        const submitLabel = stickyBar.querySelector("[data-sticky-atc-submit-label]");
        const quantity = stickyBar.querySelector("[data-sticky-atc-quantity]");
        const minusButton = stickyBar.querySelector("[data-sticky-atc-minus]");
        const plusButton = stickyBar.querySelector("[data-sticky-atc-plus]");
        const sectionWrapper = stickyBar.closest(".shopify-section, .section-sticky-atc-bar");
        const mainPurchasePanel = document.querySelector(
          ".nghs-product-buy-card, .product .product__info-wrapper, .main-product .product__info-wrapper"
        );

        let isClosed = false;
        let editorPreview = false;
        let ticking = false;

        function setVisible(visible) {
          const shouldShow = Boolean(visible) && !isClosed;
          stickyBar.classList.toggle("is-visible", shouldShow);
          stickyBar.classList.toggle("atc-visible", shouldShow);
          stickyBar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        }

        function updateVisibility() {
          ticking = false;

          if (editorPreview) {
            setVisible(true);
            return;
          }

          if (isClosed) {
            setVisible(false);
            return;
          }

          if (mainPurchasePanel) {
            const panelRect = mainPurchasePanel.getBoundingClientRect();
            const revealLine = Math.max(92, Math.min(220, window.innerHeight * .18));
            setVisible(panelRect.bottom <= revealLine);
            return;
          }

          setVisible(window.scrollY > Math.max(420, window.innerHeight * .65));
        }

        function requestVisibilityUpdate() {
          if (ticking) {
            return;
          }

          ticking = true;
          window.requestAnimationFrame(updateVisibility);
        }

        function updateSelectedVariant() {
          if (!variantSelect) {
            return;
          }

          const option = variantSelect.options[variantSelect.selectedIndex];

          if (!option) {
            return;
          }

          if (price && option.dataset.price) {
            price.textContent = option.dataset.price;
          }

          if (comparePrice) {
            const nextComparePrice = option.dataset.comparePrice || "";
            comparePrice.textContent = nextComparePrice;
            comparePrice.hidden = !nextComparePrice;
          }

          if (image && option.dataset.image) {
            image.style.opacity = "0";
            image.style.transform = "scale(.96)";

            window.setTimeout(() => {
              image.src = option.dataset.image;
              image.alt = option.dataset.imageAlt || image.alt;
              image.style.opacity = "1";
              image.style.transform = "scale(1)";
            }, 120);
          }

          if (submitButton) {
            const available = option.dataset.available === "true";
            submitButton.disabled = !available;
            submitButton.setAttribute("aria-disabled", String(!available));

            if (submitLabel) {
              submitLabel.textContent = available
                ? submitButton.dataset.addLabel || "Add to cart"
                : submitButton.dataset.soldLabel || "Sold out";
            }
          }
        }

        function setQuantity(nextQuantity) {
          if (!quantity) {
            return;
          }

          const minimum = Math.max(1, Number(quantity.min || 1));
          quantity.value = String(Math.max(minimum, Number(nextQuantity) || minimum));
          quantity.dispatchEvent(new Event("change", { bubbles: true }));
        }

        if (closeButton) {
          closeButton.addEventListener("click", () => {
            isClosed = true;
            stickyBar.classList.add("is-closed");
            setVisible(false);
          }, { signal });
        }

        if (variantSelect) {
          variantSelect.addEventListener("change", updateSelectedVariant, { signal });
          updateSelectedVariant();

          document.querySelectorAll('.nghs-product-select, variant-select select[name="id"]').forEach((mainSelect) => {
            if (stickyBar.contains(mainSelect)) {
              return;
            }

            mainSelect.addEventListener("change", () => {
              const matchingOption = Array.from(variantSelect.options).find(
                (option) => option.value === mainSelect.value
              );

              if (matchingOption) {
                variantSelect.value = matchingOption.value;
                updateSelectedVariant();
              }
            }, { signal });
          });
        }

        if (minusButton && quantity) {
          minusButton.addEventListener("click", () => {
            setQuantity(Number(quantity.value || 1) - 1);
          }, { signal });
        }

        if (plusButton && quantity) {
          plusButton.addEventListener("click", () => {
            setQuantity(Number(quantity.value || 1) + 1);
          }, { signal });
        }

        if (quantity) {
          quantity.addEventListener("change", () => {
            const minimum = Math.max(1, Number(quantity.min || 1));
            quantity.value = String(Math.max(minimum, Number(quantity.value) || minimum));
          }, { signal });
        }

        window.addEventListener("scroll", requestVisibilityUpdate, { passive: true, signal });
        window.addEventListener("resize", requestVisibilityUpdate, { passive: true, signal });

        document.addEventListener("shopify:section:select", (event) => {
          const selectedSectionId = String(event.detail && event.detail.sectionId || "");
          const currentSectionId = String(stickyBar.dataset.sectionId || "");

          if (selectedSectionId === currentSectionId || (sectionWrapper && event.target === sectionWrapper)) {
            editorPreview = true;
            isClosed = false;
            stickyBar.classList.remove("is-closed");
            setVisible(true);
          }
        }, { signal });

        document.addEventListener("shopify:section:deselect", (event) => {
          const deselectedSectionId = String(event.detail && event.detail.sectionId || "");
          const currentSectionId = String(stickyBar.dataset.sectionId || "");

          if (deselectedSectionId === currentSectionId || (sectionWrapper && event.target === sectionWrapper)) {
            editorPreview = false;
            requestVisibilityUpdate();
          }
        }, { signal });

        document.addEventListener("shopify:section:unload", (event) => {
          if (sectionWrapper && event.target === sectionWrapper) {
            controller.abort();
          }
        }, { signal });

        updateVisibility();
      });
    }

    initializeStickyAddToCart();

    document.addEventListener("shopify:section:load", (event) => {
      initializeStickyAddToCart(event.target);
    });

    function initializeFeaturedProducts(scope = document) {
      scope.querySelectorAll("[data-nghs-featured-product]").forEach((section) => {
        if (section.dataset.featuredProductInitialized === "true") {
          return;
        }

        section.dataset.featuredProductInitialized = "true";

        const featuredImage = section.querySelector(".nghs-product-featured-image");
        const thumbnails = Array.from(section.querySelectorAll("[data-featured-product-thumb]"));
        const variantSelect = section.querySelector("[data-featured-product-variant]");
        const price = section.querySelector("[data-featured-product-price]");
        const comparePrice = section.querySelector("[data-featured-product-compare]");
        const saleBadge = section.querySelector("[data-featured-product-sale]");
        const status = section.querySelector("[data-featured-product-status]");
        const submitButton = section.querySelector("[data-featured-product-submit]");
        const submitLabel = section.querySelector("[data-featured-product-submit-label]");

        function setFeaturedImage(source, alternativeText = "") {
          if (!featuredImage || !source) {
            return;
          }

          featuredImage.removeAttribute("srcset");
          featuredImage.removeAttribute("sizes");
          featuredImage.src = source;
          featuredImage.alt = alternativeText;
        }

        function setActiveThumbnail(activeThumbnail) {
          thumbnails.forEach((thumbnail) => {
            const isActive = thumbnail === activeThumbnail;
            thumbnail.classList.toggle("is-active", isActive);

            if (isActive) {
              thumbnail.setAttribute("aria-current", "true");
            } else {
              thumbnail.removeAttribute("aria-current");
            }
          });
        }

        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener("click", () => {
            setFeaturedImage(thumbnail.dataset.fullSrc, thumbnail.dataset.fullAlt || "");
            setActiveThumbnail(thumbnail);
          });
        });

        function updateVariant() {
          if (!variantSelect || !variantSelect.selectedOptions.length) {
            return;
          }

          const selectedOption = variantSelect.selectedOptions[0];
          const available = selectedOption.dataset.available === "true";
          const comparePriceText = selectedOption.dataset.comparePrice || "";

          if (price) {
            price.textContent = selectedOption.dataset.price || "";
          }

          if (comparePrice) {
            comparePrice.textContent = comparePriceText;
            comparePrice.hidden = !comparePriceText;
          }

          if (saleBadge) {
            saleBadge.hidden = !comparePriceText;
          }

          if (status) {
            status.textContent = available
              ? section.dataset.inStockLabel || "In stock"
              : section.dataset.soldOutLabel || "Sold out";
            status.classList.toggle("is-available", available);
          }

          if (submitButton) {
            submitButton.disabled = !available;
          }

          if (submitLabel) {
            submitLabel.textContent = available
              ? section.dataset.addLabel || "Add to cart"
              : section.dataset.soldOutLabel || "Sold out";
          }

          if (selectedOption.dataset.imageSrc) {
            setFeaturedImage(selectedOption.dataset.imageSrc, selectedOption.dataset.imageAlt || "");
            const matchingThumbnail = thumbnails.find((thumbnail) => (
              thumbnail.dataset.fullSrc === selectedOption.dataset.imageSrc
            ));

            if (matchingThumbnail) {
              setActiveThumbnail(matchingThumbnail);
            }
          }
        }

        if (variantSelect) {
          variantSelect.addEventListener("change", updateVariant);
          updateVariant();
        }
      });
    }

    initializeFeaturedProducts();

    document.addEventListener("shopify:section:load", (event) => {
      initializeFeaturedProducts(event.target);
    });

    function initializeRelatedProductSliders(scope = document) {
      scope.querySelectorAll("[data-related-content]").forEach((relatedSection) => {
        if (relatedSection.dataset.relatedSliderInitialized === "true") {
          return;
        }

        const viewport = relatedSection.querySelector("[data-related-viewport]");
        const grid = relatedSection.querySelector("[data-related-grid]");

        if (!viewport || !grid) {
          return;
        }

        relatedSection.dataset.relatedSliderInitialized = "true";

        const previousButton = relatedSection.querySelector("[data-related-previous]");
        const nextButton = relatedSection.querySelector("[data-related-next]");
        const navigation = relatedSection.querySelector(".nghs-related__navigation");
        const progress = relatedSection.querySelector("[data-related-progress]");
        let ticking = false;

        function updateSliderState() {
          ticking = false;

          const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          const currentScroll = Math.max(0, viewport.scrollLeft);
          const atStart = currentScroll <= 2;
          const atEnd = maximumScroll <= 2 || currentScroll >= maximumScroll - 2;

          if (navigation) {
            navigation.hidden = maximumScroll <= 2;
          }

          if (previousButton) {
            previousButton.disabled = atStart;
          }

          if (nextButton) {
            nextButton.disabled = atEnd;
          }

          if (progress) {
            const visibleRatio = viewport.scrollWidth > 0
              ? Math.min(1, (currentScroll + viewport.clientWidth) / viewport.scrollWidth)
              : 1;
            progress.style.width = `${Math.max(8, visibleRatio * 100)}%`;
          }
        }

        function requestSliderUpdate() {
          if (ticking) {
            return;
          }

          ticking = true;
          window.requestAnimationFrame(updateSliderState);
        }

        function getScrollDistance() {
          const firstCard = grid.querySelector(".nghs-related__item");
          const gridStyles = window.getComputedStyle(grid);
          const gap = Number.parseFloat(gridStyles.columnGap || gridStyles.gap || 0);

          return firstCard ? firstCard.getBoundingClientRect().width + gap : viewport.clientWidth * .8;
        }

        if (previousButton) {
          previousButton.addEventListener("click", () => {
            viewport.scrollBy({ left: -getScrollDistance(), behavior: "smooth" });
          });
        }

        if (nextButton) {
          nextButton.addEventListener("click", () => {
            viewport.scrollBy({ left: getScrollDistance(), behavior: "smooth" });
          });
        }

        viewport.addEventListener("scroll", requestSliderUpdate, { passive: true });
        window.addEventListener("resize", requestSliderUpdate, { passive: true });
        updateSliderState();
      });
    }

    function initializeRelatedProducts(scope = document) {
      scope.querySelectorAll("[data-nghs-related-products]").forEach((recommendationsElement) => {
        if (recommendationsElement.dataset.relatedProductsInitialized === "true") {
          initializeRelatedProductSliders(recommendationsElement);
          return;
        }

        recommendationsElement.dataset.relatedProductsInitialized = "true";

        if (recommendationsElement.querySelector("[data-related-content]")) {
          recommendationsElement.classList.add("is-loaded");
          initializeRelatedProductSliders(recommendationsElement);
          return;
        }

        const recommendationsUrl = recommendationsElement.dataset.url;

        if (!recommendationsUrl) {
          return;
        }

        const externalRecommendationsComponent = window.customElements
          ? window.customElements.get("product-recommendations")
          : null;

        if (externalRecommendationsComponent) {
          const observer = new MutationObserver(() => {
            if (recommendationsElement.querySelector("[data-related-content]")) {
              recommendationsElement.classList.add("is-loaded");
              initializeRelatedProductSliders(recommendationsElement);
              observer.disconnect();
            }
          });

          observer.observe(recommendationsElement, { childList: true, subtree: true });
          return;
        }

        fetch(recommendationsUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Unable to load product recommendations (${response.status})`);
            }

            return response.text();
          })
          .then((responseText) => {
            const responseDocument = new DOMParser().parseFromString(responseText, "text/html");
            const sectionId = recommendationsElement.dataset.sectionId || "";
            const escapedSectionId = window.CSS && CSS.escape ? CSS.escape(sectionId) : sectionId;
            const incomingRecommendations = responseDocument.querySelector(
              `[data-nghs-related-products][data-section-id="${escapedSectionId}"]`
            ) || responseDocument.querySelector("[data-nghs-related-products]");

            if (!incomingRecommendations) {
              throw new Error("Product recommendation response did not contain the requested section");
            }

            const hasRecommendations = Boolean(incomingRecommendations.querySelector("[data-related-content]"));
            recommendationsElement.innerHTML = incomingRecommendations.innerHTML;
            recommendationsElement.classList.add("is-loaded");

            if (!hasRecommendations && !(window.Shopify && Shopify.designMode)) {
              const sectionWrapper = recommendationsElement.closest(".shopify-section, .section-related-products");
              if (sectionWrapper) {
                sectionWrapper.hidden = true;
              }
              return;
            }

            initializeRelatedProductSliders(recommendationsElement);
            applyScrollAnimation(".nghs-related-card", "fade-up", {
              stagger: 90,
              resetEvery: 4,
              duration: 680,
              offset: 35
            });

            if (window.AOS) {
              window.setTimeout(() => AOS.refreshHard(), 30);
            }
          })
          .catch((error) => {
            const loadingState = recommendationsElement.querySelector("[data-related-loading]");
            if (loadingState) {
              loadingState.classList.add("is-error");
              const message = loadingState.querySelector("p");
              if (message) {
                message.textContent = "Recommendations are temporarily unavailable.";
              }
            }
            console.error(error);
          });
      });
    }

    initializeRelatedProducts();

    document.addEventListener("shopify:section:load", (event) => {
      initializeRelatedProducts(event.target);
    });

    function initializeCollapsibleContent(scope = document) {
      scope.querySelectorAll("[data-nghs-collapsible]").forEach((section) => {
        if (section.dataset.collapsibleInitialized === "true") {
          return;
        }

        section.dataset.collapsibleInitialized = "true";
        const exclusive = section.dataset.exclusive === "true";
        const rows = Array.from(section.querySelectorAll(".nghs-collapsible__item"));

        rows.forEach((row) => {
          row.addEventListener("toggle", () => {
            if (row.open && exclusive) {
              rows.forEach((otherRow) => {
                if (otherRow !== row) {
                  otherRow.open = false;
                }
              });
            }

            if (window.AOS) {
              window.setTimeout(() => AOS.refresh(), 40);
            }
          });
        });
      });
    }

    initializeCollapsibleContent();

    document.addEventListener("shopify:section:load", (event) => {
      initializeCollapsibleContent(event.target);
    });

    function initializePageContentComposition() {
      document.querySelectorAll(".shopify-section.has-attached-collapsible").forEach((section) => {
        section.classList.remove("has-attached-collapsible");
      });

      document.querySelectorAll(".section-collapsible-content.is-page-content-section").forEach((section) => {
        section.classList.remove("is-page-content-section", "is-page-content-first", "is-page-content-last");
      });

      const processedWrappers = new Set();
      document.querySelectorAll("[data-nghs-main-page], .nghs-main-page-section").forEach((mainPage) => {
        const mainWrapper = mainPage.closest(".shopify-section");

        if (!mainWrapper || processedWrappers.has(mainWrapper)) {
          return;
        }

        processedWrappers.add(mainWrapper);
        const connectedSections = [];
        let candidate = mainWrapper.nextElementSibling;

        while (candidate && candidate.classList.contains("section-collapsible-content")) {
          connectedSections.push(candidate);
          candidate = candidate.nextElementSibling;
        }

        if (!connectedSections.length) {
          return;
        }

        mainWrapper.classList.add("has-attached-collapsible");
        connectedSections.forEach((section, index) => {
          section.classList.add("is-page-content-section");
          section.classList.toggle("is-page-content-first", index === 0);
          section.classList.toggle("is-page-content-last", index === connectedSections.length - 1);
        });
      });
    }

    initializePageContentComposition();

    ["shopify:section:load", "shopify:section:unload", "shopify:section:reorder"].forEach((eventName) => {
      document.addEventListener(eventName, () => {
        window.requestAnimationFrame(initializePageContentComposition);
      });
    });

    function initializeCarts(scope = document) {
      scope.querySelectorAll("[data-nghs-cart]").forEach((cartSection) => {
        if (cartSection.dataset.cartInitialized === "true") {
          return;
        }

        cartSection.dataset.cartInitialized = "true";
        const form = cartSection.querySelector(".nghs-cart__form");

        if (!form) {
          return;
        }

        const updateButton = form.querySelector("[data-cart-update]");
        const status = form.querySelector("[data-cart-status]");
        const controller = new AbortController();
        const { signal } = controller;
        let updateTimer = 0;

        function getNumber(value, fallback) {
          const number = Number(value);
          return Number.isFinite(number) ? number : fallback;
        }

        function updateButtonStates(quantityControl) {
          const input = quantityControl.querySelector("[data-cart-quantity-input]");
          const minusButton = quantityControl.querySelector("[data-cart-minus]");
          const plusButton = quantityControl.querySelector("[data-cart-plus]");

          if (!input) {
            return;
          }

          const value = getNumber(input.value, 1);
          const minimum = getNumber(input.min, 1);
          const maximum = input.max === "" ? Infinity : getNumber(input.max, Infinity);

          if (minusButton) {
            minusButton.disabled = value <= minimum;
          }

          if (plusButton) {
            plusButton.disabled = value >= maximum;
          }
        }

        function submitUpdate() {
          window.clearTimeout(updateTimer);

          if (!form.checkValidity()) {
            form.reportValidity();
            return;
          }

          form.classList.add("is-updating");
          form.setAttribute("aria-busy", "true");

          if (status) {
            status.textContent = "Updating cart";
          }

          if (form.requestSubmit && updateButton) {
            form.requestSubmit(updateButton);
          } else {
            form.submit();
          }
        }

        function queueUpdate() {
          window.clearTimeout(updateTimer);
          updateTimer = window.setTimeout(submitUpdate, 450);
        }

        form.querySelectorAll("[data-cart-quantity]").forEach((quantityControl) => {
          const input = quantityControl.querySelector("[data-cart-quantity-input]");
          const minusButton = quantityControl.querySelector("[data-cart-minus]");
          const plusButton = quantityControl.querySelector("[data-cart-plus]");

          if (!input) {
            return;
          }

          function changeQuantity(direction) {
            const minimum = getNumber(input.min, 1);
            const maximum = input.max === "" ? Infinity : getNumber(input.max, Infinity);
            const increment = Math.max(getNumber(input.step, 1), 1);
            const currentValue = getNumber(input.value, minimum);
            const nextValue = Math.min(maximum, Math.max(minimum, currentValue + (increment * direction)));

            if (nextValue === currentValue) {
              return;
            }

            input.value = String(nextValue);
            updateButtonStates(quantityControl);
            queueUpdate();
          }

          if (minusButton) {
            minusButton.addEventListener("click", () => changeQuantity(-1), { signal });
          }

          if (plusButton) {
            plusButton.addEventListener("click", () => changeQuantity(1), { signal });
          }

          input.addEventListener("change", () => {
            const minimum = getNumber(input.min, 1);
            const maximum = input.max === "" ? Infinity : getNumber(input.max, Infinity);
            const nextValue = Math.min(maximum, Math.max(minimum, getNumber(input.value, minimum)));

            input.value = String(nextValue);
            updateButtonStates(quantityControl);
            queueUpdate();
          }, { signal });

          updateButtonStates(quantityControl);
        });

        form.querySelectorAll(".nghs-cart__remove").forEach((removeLink) => {
          removeLink.addEventListener("click", () => {
            window.clearTimeout(updateTimer);
            form.classList.add("is-updating");
            form.setAttribute("aria-busy", "true");

            if (status) {
              status.textContent = "Removing item from cart";
            }
          }, { signal });
        });

        form.addEventListener("submit", () => {
          window.clearTimeout(updateTimer);
          form.classList.add("is-updating");
          form.setAttribute("aria-busy", "true");
        }, { signal });

        document.addEventListener("shopify:section:unload", (event) => {
          if (event.target.contains(cartSection)) {
            window.clearTimeout(updateTimer);
            controller.abort();
          }
        }, { signal });
      });
    }

    initializeCarts();

    document.addEventListener("shopify:section:load", (event) => {
      initializeCarts(event.target);
    });
